<template>
  <modal-component
    :label="otroDomicilio ? 'Otro domicilio' : 'Modificar domicilio'"
    button-label="Listo"
    @close="$emit('close', false)"
    :changeAddress="true"
    @aceptar="aceptar"
    :show="show"
    class="address"
    :disable="domicilio.valido === false"
    analyticsName="listo"
    :analyticsSubmodule="
      otroDomicilio ? 'otro domicilio' : 'modificar domicilio'
    "
  >
    <address-data-old
      v-if="paquete"
      v-model="value"
      :searchEncontesa="value.searchEncontesa"
      :otroDomicilio="otroDomicilio"
      :step4="true"
      @valid="$emit('close', true)"
      :quantumObfuscate="quantumObfuscate"
    />
    <address-data
      v-else
      v-model="domicilio"
      :otroDomicilio="otroDomicilio"
      :step4="true"
      @valid="$emit('close', true)"
      :quantumObfuscate="quantumObfuscate"
    />
  </modal-component>
</template>

<script>
import AddressData from "@/components/core/AddressData";
import AddressDataOld from "@/components/core/AddressDataOld";
import ModalComponent from "@/components/core/ModalComponent";
import { PCG7 } from "@/config/constants";
import cloneDeep from "lodash/cloneDeep";
import { DO_NORMALIZAR_DOMICILIO } from "@/config/constants/action-types";
export default {
  name: "ChangeAddress",
  components: {
    ModalComponent,
    AddressDataOld,
    AddressData
  },
  props: {
    value: Object,
    show: {
      type: Boolean,
      default: false
    },
    otroDomicilio: {
      type: Boolean,
      default: false
    },
    quantumObfuscate: {
      type: Boolean,
      default: false
    },
    paquete: Boolean
  },
  data() {
    return {
      domicilio: this.value
    };
  },
  watch: {
    value: function(newValue, oldValue) {
      if (this.paquete) {
        if (!oldValue.valido && newValue.valido) {
          this.$emit("aceptar");
          document
            .getElementsByTagName("html")[0]
            .classList.remove("lock-scroll");
        }
      } else {
        this.domicilio = cloneDeep(newValue);
      }
    }
  },
  mounted() {
    if (this.paquete) return;
    // Watch del domicilio
    this.$store.watch(
      this.$store.getters.getValidandoDomicilio,
      (value, oldVal) => {
        if (oldVal === true && value === false) {
          // Se validó correctamente el domicilio
          // Cerrar modal
          setTimeout(() => {
            this.$emit("aceptar");
            document
              .getElementsByTagName("html")[0]
              .classList.remove("lock-scroll");
          }, 0);
        }
      },
      { immediate: true }
    );
  },
  methods: {
    aceptar() {
      if (this.paquete) {
        this.$store
          .dispatch(DO_NORMALIZAR_DOMICILIO, {
            payload: this.value,
            selectDomicilio: this.otroDomicilio ? "otro" : "particular"
          })
          .then(value => {
            if (value) {
              this.$emit("aceptar");
              document
                .getElementsByTagName("html")[0]
                .classList.remove("lock-scroll");
            }
          });
      } else {
        this.$store.dispatch("DO_VALIDAR_DOMICILIO", {
          modelDomicilio: this.domicilio,
          tipoDomicilio: this.otroDomicilio
            ? PCG7.TDOMIC.CORRESPONDENCIA
            : PCG7.TDOMIC.PARTICULAR
        });
      }
    }
  }
};
</script>
